module.exports = __webpack_public_path__ + "components/flag/static/square/bv-ec636c0d4a956692f2d11a4d3e4f8414.svg";